import axios from 'axios'
import { Env, readFromEnv } from '@cinch-nx/environments'
import { datadogRum } from '@datadog/browser-rum'
import { formatPostcode } from '../../utils/postcode-helper'
import { AutocompleteResponse, AddressDetails } from './types'

const idealPostcodesClient = axios.create({
  baseURL: readFromEnv(Env.IdealPostcodesUrl),
  params: {
    api_key: readFromEnv(Env.IdealPostcodesApiKey),
  },
  validateStatus: () => true,
})

export const findAddresses = async (postcode: string) => {
  try {
    const response = await idealPostcodesClient.request<AutocompleteResponse>({
      method: 'GET',
      url: `/v1/autocomplete/addresses?query=${formatPostcode(postcode)}`,
    })

    if (!response || !response.data?.result?.hits) {
      datadogRum.addError('Cinch Servicing: Find Addresses - No Results', {
        cinchServicing: true,
        apiEndpoint: '/v1/autocomplete/addresses',
        postcode: formatPostcode(postcode),
        resultCount: 0,
      })
      return []
    }

    return response.data.result.hits
  } catch (error) {
    datadogRum.addError(new Error('Cinch Servicing: Find Addresses Error'), {
      cinchServicing: true,
      apiEndpoint: '/v1/autocomplete/addresses',
      postcode: formatPostcode(postcode),
      error: error,
    })
    throw error
  }
}

export const getAddressDetails = async (addressId: string) => {
  try {
    const response = await idealPostcodesClient.request<AddressDetails>({
      method: 'GET',
      url: `/v1/autocomplete/addresses/${addressId}/gbr`,
    })

    if (!response || !response?.data?.result) {
      datadogRum.addAction('Cinch Servicing: Get Address Details - No Data', {
        cinchServicing: true,
        apiEndpoint: `/v1/autocomplete/addresses/${addressId}/gbr`,
        addressId,
      })
      return null
    }

    return {
      addressLine1: response.data.result.line_1,
      addressLine2: response.data.result.line_2,
      postTown: response.data.result.post_town,
      county: response.data.result.county,
      postcode: response.data.result.postcode,
    }
  } catch (error) {
    datadogRum.addError(
      new Error('Cinch Servicing: Get Address Details Error'),
      {
        cinchServicing: true,
        apiEndpoint: `/v1/autocomplete/addresses/${addressId}/gbr`,
        addressId,
        error: error,
      },
    )
    return null
  }
}
